import { differenceInCalendarDays } from 'date-fns'

import {
  formatModelDate,
  formatRangeLabel,
  parseModelDate,
} from '@/components/lemmala-design-system/table/utils/date-range-filter'

import type { CustomRange } from './types'

// Custom ranges travel as `yyyy-MM-dd_yyyy-MM-dd` (inclusive), so they fit in a URL param.
export const encodeCustomRange = ({ from, to }: CustomRange) =>
  `${formatModelDate(from)}_${formatModelDate(to)}`

export const parseCustomRange = (value?: string | null): CustomRange | undefined => {
  const [from, to] = (value?.split('_') ?? []).map(parseModelDate)
  return from && to && from <= to ? { from, to } : undefined
}

export const formatCustomRange = ({ from, to }: CustomRange) =>
  formatRangeLabel(from, to, 'shortDateTime')

export const customRangeDays = ({ from, to }: CustomRange) => differenceInCalendarDays(to, from) + 1
